import { Badge } from '@/components/ui/Badge'
import { humanize } from '@/utils/format'
import { leaveStatusTone, type LeaveColour, type LeaveStatus } from '../types'

export function LeaveStatusBadge({ status, size = 'sm' }: { status: LeaveStatus; size?: 'sm' | 'md' }) {
  return (
    <Badge tone={leaveStatusTone[status]} dot size={size}>
      {humanize(status)}
    </Badge>
  )
}

export function LeaveTypeBadge({
  name,
  colour,
  size = 'sm',
}: {
  name: string
  colour: LeaveColour
  size?: 'sm' | 'md'
}) {
  return (
    <Badge tone={colour} size={size}>
      {name}
    </Badge>
  )
}
